var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityCollaboration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 44,
    viewBox: "0 0 74 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3996 2.4124L26.196 11.3664C24.346 12.8464 23.976 15.5104 25.3968 17.4196C26.8768 19.4472 29.7776 19.8468 31.7904 18.3076L43.2604 9.5016C44.0744 8.88 45.2288 9.028 45.8652 9.8124C46.5016 10.6116 46.3536 11.766 45.5396 12.3876L43.1272 14.2376L63.6104 32.8412H68.45C71.5136 32.8412 74 30.3992 74 27.3652V12.7724C74 9.7532 71.5136 7.2964 68.45 7.2964H59.126L58.6672 7.0152L50.2756 1.7168C48.4996 0.592001 46.4276 0 44.326 0C41.81 0 39.3532 0.8584 37.3996 2.4124ZM40.034 16.6056L34.0548 21.1936C30.414 23.9908 25.1304 23.2656 22.3924 19.5656C19.832 16.0876 20.4832 11.2332 23.8576 8.5248L33.4776 0.8584C32.1456 0.296 30.6952 0.0148009 29.23 0.0148009C27.0544 9.03383e-07 24.938 0.6364 23.1176 1.8204L14.8 7.2964H5.55C2.4864 7.2964 0 9.7532 0 12.7724V27.3652C0 30.3992 2.4864 32.8412 5.55 32.8412H18.056L28.6232 42.3576C30.8876 44.4 34.3952 44.2372 36.4672 42.0024C37.1036 41.3068 37.5328 40.4928 37.7548 39.6492L39.7232 41.44C41.9728 43.4824 45.4804 43.3344 47.5524 41.0996C48.0704 40.552 48.4552 39.9008 48.7068 39.22C50.9416 40.7 53.9904 40.404 55.8848 38.3616C57.9568 36.1416 57.794 32.6784 55.5444 30.636L40.034 16.6056Z",
    fill: "#1471C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityCollaboration);
export default __webpack_public_path__ + "static/media/activity-collaboration.b8108b23652499bed0c19d9dc81d377a.svg";
export { ForwardRef as ReactComponent };